export default "__VITE_ASSET__5aba215c__"